import { render, staticRenderFns } from "./CommentBlock.vue?vue&type=template&id=4e7f36c3"
import script from "./CommentBlock.vue?vue&type=script&lang=js"
export * from "./CommentBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports